import { useEffect, useRef } from 'react';
import simpleS3Handler from '../utils/simpleS3Handler';

/**
 * React hook for simple S3 link handling
 * Automatically initializes and cleans up the S3 link handler
 */
export const useSimpleS3Handler = (enabled: boolean = true) => {
  const isInitialized = useRef(false);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!isInitialized.current) {
      simpleS3Handler.init();
      isInitialized.current = true;
    }

    // Cleanup on unmount
    return () => {
      if (isInitialized.current) {
        simpleS3Handler.destroy();
        isInitialized.current = false;
      }
    };
  }, [enabled]);

  return {
    isInitialized: isInitialized.current
  };
};
